// @flow
import update from 'immutability-helper';
import { Observable, of } from 'rxjs';
import { ofType } from 'redux-observable';
import { catchError, mergeMap, map } from 'rxjs/operators';
import { postContactMessageApi } from './api'

import { setNewAlert } from '../alert/duck';

import type { HTTPError } from '../../error';

export type ContactMessageRequest = {
  email: string;
  subject: string;
  message: string;
};

export type CargoAction = {
  +type: string;
  +error?: HTTPError;
  +contactMessage?: ContactMessageRequest;
};

export type CargoState = {
  +isPostingContactMessage?: boolean;
  +postContactMessageSuccess?: boolean;
  +postContactMessageError?: HTTPError;
};

const CARGO_POST_CONTACT_MESSAGE_REQUEST = 'CARGO_POST_CONTACT_MESSAGE_REQUEST';
const CARGO_POST_CONTACT_MESSAGE_SUCCESS = 'CARGO_POST_CONTACT_MESSAGE_SUCCESS';
const CARGO_POST_CONTACT_MESSAGE_ERROR = 'CARGO_POST_CONTACT_MESSAGE_ERROR';

export function cargoPostContactMessage(contactMessage: ContactMessageRequest): CargoAction {
  return {
    type: CARGO_POST_CONTACT_MESSAGE_REQUEST,
    contactMessage,
  };
}

export function cargoPostContactMessageSuccessFn(): CargoAction {
  return {
    type: CARGO_POST_CONTACT_MESSAGE_SUCCESS,
  };
}

export function cargoPostContactMessageErrorFn(error: HTTPError): CargoAction {
  return {
    type: CARGO_POST_CONTACT_MESSAGE_ERROR,
    error,
  };
}

export const actions = {
  CARGO_POST_CONTACT_MESSAGE_REQUEST,
  CARGO_POST_CONTACT_MESSAGE_SUCCESS,
  CARGO_POST_CONTACT_MESSAGE_ERROR,
  cargoPostContactMessage,
  cargoPostContactMessageSuccessFn,
  cargoPostContactMessageErrorFn,
};

export const initialState: CargoState = {};

export default function reducer(state: CargoState = initialState,
                                action: CargoAction): CargoState {
  switch (action.type) {
    case CARGO_POST_CONTACT_MESSAGE_REQUEST:
      return update(state, {
        $unset: ['postContactMessageSuccess', 'postContactMessageError'],
        isPostingContactMessage: { $set: true },
      });
    case CARGO_POST_CONTACT_MESSAGE_SUCCESS:
      return update(state, {
        $unset: ['isPostingContactMessage', 'postContactMessageError'],
        postContactMessageSuccess: { $set: true },
      });
    case CARGO_POST_CONTACT_MESSAGE_ERROR:
      return update(state, {
        $unset: ['isPostingContactMessage'],
        postContactMessageError: { $set: action.error }
      });
    default:
      return state;
  }
}

export function cargoPostContactMessageEpic(action$: Observable<CargoAction>): Observable<CargoAction> {
  return action$.pipe(
    ofType(CARGO_POST_CONTACT_MESSAGE_REQUEST),
    mergeMap(({ contactMessage }) => postContactMessageApi(contactMessage).pipe(
      map(() => cargoPostContactMessageSuccessFn()),
      catchError((e: HTTPError) => {
        if (Math.round(e.code / 100) === 5) {
          return of(cargoPostContactMessageErrorFn(e),
            setNewAlert('cargo', 'error', undefined, 'httpErrors.post.500'),
          );
        } else if (e.code === 400) {
          return of(cargoPostContactMessageErrorFn(e),
            setNewAlert('cargo', 'error', undefined, 'httpErrors.post.400'),
          );
        }
        return of(cargoPostContactMessageErrorFn(e));
      })))
  );
}



// WEBPACK FOOTER //
// ./src/modules/cargo/duck.js